import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=6c9bf613&scoped=true"
import script from "./DocumentListItem.vue?vue&type=script&lang=js"
export * from "./DocumentListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9bf613",
  null
  
)

export default component.exports